import { render, staticRenderFns } from "./jikaoZj.vue?vue&type=template&id=6ccce8a2&scoped=true"
import script from "./jikaoZj.vue?vue&type=script&lang=js"
export * from "./jikaoZj.vue?vue&type=script&lang=js"
import style0 from "./jikaoZj.vue?vue&type=style&index=0&id=6ccce8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccce8a2",
  null
  
)

export default component.exports